'use strict';

var React = require('react');
var SVG = require('./svg');

/*
 * Usage: <Curve start={{ x: 2, y: 2 }} end={{ x: 2, y: 2 }} color="#898989" strokeWidth="1.5" />
 */

var Curve = React.createClass({
  displayName: 'Curve',

  render: function render() {
    var component = this;
    var _component$props = component.props;
    var start = _component$props.start;
    var end = _component$props.end;
    var color = _component$props.color;
    var strokeWidth = _component$props.strokeWidth;

    var maxOffset = 25;
    var verticalDiff = Math.abs(start.y - end.y);
    var horizontalDiff = Math.abs(start.x - end.x);
    var offset = Math.min(25, Math.max(verticalDiff, horizontalDiff));

    var controlPoint1 = {
      x: start.x,
      y: start.y
    };

    var controlPoint2 = {
      x: Math.max(start.x + offset, end.x + (start.x - end.x) / 2),
      y: start.y
    };

    var controlPoint3 = {
      x: Math.min(end.x - offset, start.x + (end.x - start.x) / 2),
      y: end.y
    };

    var controlPoint4 = {
      x: end.x,
      y: end.y
    };

    var d = 'M' + controlPoint1.x + ' ' + controlPoint1.y + ' C ' + controlPoint2.x + ' ' + controlPoint2.y + ', ' + controlPoint3.x + ' ' + controlPoint3.y + ', ' + controlPoint4.x + ' ' + controlPoint4.y;

    component.props.bezier = [controlPoint1, controlPoint2, controlPoint3, controlPoint4];

    return React.createElement(
      SVG,
      { width: '100%', height: '100%' },
      React.createElement('path', {
        d: d,
        fill: 'transparent',
        stroke: color,
        strokeWidth: strokeWidth })
    );
  }
});

module.exports = Curve;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/graphics/curve.js
 **/